"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginError = void 0;
var tslib_1 = require("tslib");
var basePlugin_1 = tslib_1.__importDefault(require("../base/basePlugin"));
var typings_1 = require("../typings");
var const_1 = require("../utils/const");
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var util_1 = require("../utils/util");
var defaultOption = {
    sampleRate: 100,
    filters: [],
    maxLen: 10240,
};
var PluginError = /** @class */ (function (_super) {
    tslib_1.__extends(PluginError, _super);
    function PluginError(queue, config) {
        if (config === void 0) { config = defaultOption; }
        var _this = _super.call(this, queue, config) || this;
        _this.name = PluginError.id;
        _this.config = util_1.extend(defaultOption, _this.config);
        return _this;
    }
    PluginError.prototype.init = function () {
        var _this = this;
        var oldOnError = window.onerror;
        window.onerror = function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            _this.parseOnerror.apply(_this, rest);
            oldOnError && oldOnError.apply(window, rest);
        };
        window.addEventListener('unhandledrejection', function (e) {
            _this.parseUnhandleRejection(e);
        });
    };
    PluginError.prototype.parseOnerror = function (message, source, lineno, colno, error) {
        try {
            if (error && error instanceof Error) {
                this.push(error);
            }
            else {
                this.push({ message: message });
            }
        }
        catch (error) {
            logger_1.default.log('window onerror 采集异常', error);
        }
    };
    PluginError.prototype.parseUnhandleRejection = function (e) {
        if (!e || e.type !== 'unhandledrejection' || !e.reason)
            return;
        try {
            var reason = e.reason;
            if (reason instanceof Error) {
                this.push({
                    message: "[unhandlerejection] " + (reason.message || reason.name || ''),
                    stack: (reason === null || reason === void 0 ? void 0 : reason.stack) || reason.toString() || '',
                });
            }
            else {
                this.push({
                    message: "[unhandlerejection] " + reason.toString(),
                    stack: util_1.stringify(reason),
                });
            }
        }
        catch (error) {
            logger_1.default.log('unhandledrejection 异常采集失败', error);
        }
    };
    PluginError.prototype.push = function (err, level) {
        if (level === void 0) { level = typings_1.LEVEL.ERROR; }
        if (!err)
            return false;
        var error = { level: level, message: '' };
        if (err instanceof Error) {
            error.message = err.message || err.name || '';
            error.stack = (err === null || err === void 0 ? void 0 : err.stack) || '';
        }
        else if (typeof err === 'string') {
            error.message = err;
        }
        else if (typeof err === 'object') {
            error.message = err.message || util_1.stringify(err);
            error.stack = (err === null || err === void 0 ? void 0 : err.stack) || '';
        }
        if (!error.message || typeof error.message !== 'string')
            return;
        // 判断堆栈长度太大 过滤掉
        if (error.stack && error.stack.length > this.config.maxLen) {
            logger_1.default.log('异常堆栈长度超出最大值');
            return;
        }
        var filters = this.config.filters;
        if (util_1.isArray(filters)) {
            for (var _i = 0, filters_1 = filters; _i < filters_1.length; _i++) {
                var filter = filters_1[_i];
                if (error.message.indexOf(filter) === 0) {
                    return false;
                }
            }
        }
        this.addData({
            type: const_1.METRICS_JS_ERROR,
            ts: Date.now(),
            value: 1,
            tags: {
                level: error.level,
                stack: error.stack || '',
                message: error.message,
            },
        });
    };
    PluginError.prototype.addError = function (err, level) {
        if (level === void 0) { level = typings_1.LEVEL.ERROR; }
        if (typeof err !== 'string' && !(err instanceof Error) && !(err && typeof err === 'object')) {
            logger_1.default.log('err 类型必须为 string 对象 Error 中一种');
            return;
        }
        this.push(err, level);
    };
    PluginError.id = typings_1.PLUGIN_NAME.ERROR;
    return PluginError;
}(basePlugin_1.default));
exports.PluginError = PluginError;
//# sourceMappingURL=jsError.js.map